import { FC } from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';

import BackButton from 'components/BackButton';
import Loader from 'components/Loader';
import PasscodeInput from 'components/PasscodeInput';
import { ClearAllDigitsFn } from 'components/PasscodeInput/types';
import * as Layout from 'layouts/StepperLayout';

import locales from './locales';

type PinCodeProps = {
  loading: boolean;
  onPasscodeSubmit: (
    passcode: string,
    clearAllDigits: ClearAllDigitsFn,
  ) => Promise<void>;
  goBack: () => void;
};

const PinCode: FC<PinCodeProps> = ({ goBack, loading, onPasscodeSubmit }) => {
  return (
    <>
      <Layout.Root>
        <Layout.Body>
          <Layout.HeaderButtonsContainer>
            <Box visibility={loading ? 'hidden' : 'visible'}>
              <BackButton onClick={goBack} />
            </Box>
          </Layout.HeaderButtonsContainer>
          <Layout.BodyScrollableSection>
            <VStack alignItems="flex-start" spacing="space-40">
              <VStack alignItems="flex-start">
                <Heading>{locales.title}</Heading>
                <Text>{locales.description}</Text>
              </VStack>
              {loading ? (
                <Loader />
              ) : (
                <PasscodeInput hidden onSubmit={onPasscodeSubmit} />
              )}
            </VStack>
          </Layout.BodyScrollableSection>
        </Layout.Body>
      </Layout.Root>
    </>
  );
};

export default PinCode;
